import { Button } from '@ui/buttons/button';
import { Chip } from '@ui/forms/input-field/chip-field/chip';
import { DialogTrigger } from '@ui/overlays/dialog/dialog-trigger';
import { AssignLicenseDialog } from './assign-license-dialog';
import { ReleaseLicenseDialog } from './release-license-dialog';
import { Trans } from '@ui/i18n/trans';
import { FormattedDate } from '@ui/i18n/formatted-date';
import { toast } from '@ui/toast/toast';
import { useActivateLicense } from './requests/use-activate-license';
import { ConfirmationDialog } from '@ui/overlays/dialog/confirmation-dialog';
import Avatar from '../../avatar.jpg';
const ThemeColor = {
  cadetColor: "#1e90ff",
  nobleColor: "#009e60",
  regalColor: "#9238d3",
  royalColor: "#dc143c",
  eliteColor: "#A16750",
};

const PackageBadge = ({ id, active = 1, forcom = false }: { id: number, active?: number, forcom?: boolean }) => {
  if (id == 1) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.cadetColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Basic
        </span>
      </span>
    );
  }
  if (id == 2) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.nobleColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Standard
        </span>
      </span>
    );
  }
  if (id == 3) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.regalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Ultra
        </span>
      </span>
    );
  }
  if (id == 4) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.royalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Premium
        </span>
      </span>
    );
  }

  if (id == 5) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.nobleColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Standard
        </span>
      </span>
    );
  }
  if (id == 6) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.royalColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Premium
        </span>
      </span>
    );
  }
  if (id == 9) {
    return (
      <span
        className="badge-pro p-5 px-10"
        style={{
          backgroundColor: active == 1 ? ThemeColor.eliteColor : '#a9a9a9',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Elite
        </span>
      </span>
    );
  }
  if (id == 0) {
    return (
      <span
        className="badge-pro p-2"
        style={{
          backgroundColor: '#a8a8a8',
          cursor: 'pointer',
          textAlign: forcom ? 'center' : 'start',
          width: forcom ? '100%' : 'auto',
        }}
      >
        <span className="badge-link text-white" style={{ fontSize: 13 }}>
          Free
        </span>
      </span>
    );
  }
  return null;
};

interface LicenseItemProps {
  license: any;
}

export function LicenseItem({ license }: LicenseItemProps) {
  const activateLicense = useActivateLicense();

  const handleActivate = () => {
    activateLicense.mutate(
      { id: license.id },
      {
        onSuccess: () => {
          toast.positive('License activated successfully');
        },
      },
    );
  };

  const isActive = license.status === 0;
  const isAssigned = license.status === 2;
  const isActivated = license.active_data?.activated_on ?? false;
  return (
    <div className="rounded border p-16 bg-paper">
      <div className="flex items-start justify-between gap-12 mb-12">
        {/* Left side */}
        <div className="flex-1">
          <div className="mb-8">
            <PackageBadge id={license.package_id} forcom={false} />
          </div>
          <div className="text-sm font-semibold">
            <Trans message="License Key" />
            <div>
              <p> {license.key}</p>
            </div>
          </div>

        </div>

        {/* Right side */}
        <div className="text-right">
          <div className="mb-8">
            <Chip
              size="xs"
              color={isActive ? 'positive' : (license.status === 1 ? 'positive' : 'danger')}
              radius="rounded"
            >
              {isActive ? (
                <Trans message="Available" />
              ) : (
                <>
                  {license.status === 1 ? (
                    <Trans message="Assigned" />
                  ) : (
                    <Trans message="Activated" />
                  )}
                </>
              )}
            </Chip>
          </div>
          <div className="text-sm dark:text-white text-muted font-semibold mb-8">
            <Trans message="Order Date" />
            <p>{license.order_date}</p>
          </div>

          <div className="flex gap-8 pt-8">
            {license.status === 0 && (
              <DialogTrigger type="modal">
                <Button variant="outline" color="chip" size="xs">
                  <Trans message="Assign" />
                </Button>
                <AssignLicenseDialog license={license} />
              </DialogTrigger>
            )}

            {license.own === 1 && !isActivated && (
              <DialogTrigger type="modal">
                <Button variant="flat" color="primary" size="xs">
                  <Trans message="Activate" />
                </Button>
                <ConfirmationDialog
                  isDanger={false}
                  title={<Trans message="Activate License" />}
                  body={
                    <div className="text-sm">
                      <Trans message="Are you sure you want to activate this license? This action cannot be undone." />
                    </div>
                  }
                  confirm={<Trans message="Activate" />}
                  onConfirm={handleActivate}
                />
              </DialogTrigger>
            )}
          </div>
        </div>

      </div>
      {(isActivated && (license.status != 3 && license.status != 1)) && (
        <div className="text-sm text-muted mt-2 flex justify-between w-full">
          <div>
            <Trans message="Activated By" />
            <div className='flex items-center mt-2'>
              <img src={license.active_data?.userinfo?.avatar ?? Avatar} alt="Avatar" className="inline-block w-42 h-42 rounded-full mr-2" />
              <p className='text-lg ml-3'>{license.active_data?.userinfo?.username}</p>
            </div>
          </div>
          <div>
            {isActivated && (
              <div className="text-sm text-muted mb-8">
                <Trans message="Activated on" />
                <p className='mt-8'>{license.active_data?.activated_on}</p>
              </div>
            )}
          </div>
        </div>
      )}
      {(isActivated && (license.status == 1)) && (
        <div className="text-sm text-muted mt-2 flex justify-between w-full items-center">
          <div>
            <Trans message="Assigned To" />
            <div className='flex items-center mt-2'>
              <img src={license.active_data?.userinfo?.avatar ?? Avatar} alt="Avatar" className="inline-block w-42 h-42 rounded-full mr-2" />
              <p className='text-lg ml-3'>{license.active_data?.userinfo?.username}</p>
            </div>
          </div>
          <div>
            {isActivated && (
              <div className="text-sm text-muted">
                {license.status === 1 && (
                  <DialogTrigger type="modal">
                    <Button variant="outline" size="xs" color="danger">
                      <Trans message="Release" />
                    </Button>
                    <ReleaseLicenseDialog license={license} />
                  </DialogTrigger>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {license.can_assign === false && (
        <div className="mt-12 pt-12 border-t space-y-6 text-xs">
          <div className="font-medium text-sm mb-8">
            <Trans message="Active User Information" />
          </div>
          <div>
            <Trans message="Name" />: {license.active_data.userinfo?.name}
          </div>
          <div>
            <Trans message="Email" />: {license.active_data.userinfo?.email}
          </div>
          <div>
            <Trans message="Phone" />: {license.active_data.userinfo?.phone}
          </div>
          <div>
            <Trans message="Location" />:{' '}
            {license.active_data.userinfo?.city},{' '}
            {license.active_data.userinfo?.state},{' '}
            {license.active_data.userinfo?.country}
          </div>
        </div>
      )}
    </div>
  );
}
